import { Folder, File } from "../types";
import { ROOT_FOLDER } from "../constants";

export const getFileSystemItemId = (item: Folder | File) =>
  `${item.path}${item.path === ROOT_FOLDER ? "" : ROOT_FOLDER}${item.name}`;
